let WELCOME_TO_LYNKED_MENU = 'WELCOME_TO_LYNKED_MENU';

export default { WELCOME_TO_LYNKED_MENU };
